<h3 mat-dialog-title class="title">{{ data.title }}</h3>

<mat-dialog-content>
    <form [formGroup]="form">
        <div class="messages">
            <txp-message [type]="messageType.DANGER"
                        data-qa-label="ErrorMessage"
                        *ngIf="showError">
                {{ errorMessage}}
            </txp-message>
        </div>

        <div class="content" [innerHTML]="data.message"></div>

        <mat-form-field class="delete-input" *ngIf="data.input">
            <mat-label>{{ data.inputLabel }}</mat-label>
            <input #password
                    matInput
                    data-qa-label="PasswordInput"
                    minlength="3"
                    formControlName="password"
                    required>
            <span matSuffix class="lbl" (click)="password.value = ''"></span>
            <mat-error>
                {{ 'form.error.required' | translate }}
            </mat-error>
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <txp-button (click)="onAction(false)"
        [hidden]="!data.input"
        data-qa-label="CancelButton"
        [style]="buttonStyle.SECONDARY"
        [disabled]="isSaving">
        {{ data.cancelText }}
    </txp-button>
    <txp-button data-qa-label="ContinueButton"
        [style]="buttonStyle.PRIMARY"
        (click)="onAction(true)"
        [loading]="isSaving"
        [disabled]="data.input && disableContinueBtn" >
        {{ data.input ? data.confirmText : 'form.button.ok' | translate }}
    </txp-button>
</mat-dialog-actions>


